// extracted by mini-css-extract-plugin
export default {"wrapper":"preloadimage_wrapper__bY5SV","spacer":"preloadimage_spacer__ao5Up"};